import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalInfo, UserInfo } from 'src/app/models';
import { CollaboratorsService, UserService, ToastService } from 'src/app/services';


@Component({
    selector: 'app-add-edit-collaborators',
    templateUrl: './add-edit-collaborators.component.html',
    styleUrls: ['./add-edit-collaborators.component.scss'],
    standalone: false
})
export class AddEditCollaboratorsComponent implements OnInit {

  @Input() data: ModalInfo;
  @Output() sendStatusToParent = new EventEmitter<UserInfo[]>();

  list: UserInfo[] = [];
  collaborators: UserInfo[] = [];
  me: UserInfo;

  constructor(
    private collaboratorService: CollaboratorsService,
    private userService: UserService,
    private toastService: ToastService
  ) { }

  async ngOnInit() {
    try {
      await this.getCollaboratorList();
      this.me = await this.userService.getUserInfo();
    } catch (error) {
      // Wrong error response
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Send the event with the list of collaborators selected by the select to the parent component
   */

  getValue() {
    this.sendStatusToParent.emit(this.list);
  }

  /**
   * Return the list of available collaborators
   */

  async getCollaboratorList() {
    // todo: not getting correct attributes if is collaborator//
    try {
      const res = (await this.collaboratorService.getAvailableCollaborators({
        type: this.data.type, id_entity: this.data.id_entity, is_new: this.data.is_new
      })).collaborator;
      this.collaborators = res;
    } catch (error) {
      // Wrong error response
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }
}
